import { render, staticRenderFns } from "./FleetDetail.vue?vue&type=template&id=3c4c041c&scoped=true"
import script from "./FleetDetail.vue?vue&type=script&lang=js"
export * from "./FleetDetail.vue?vue&type=script&lang=js"
import style0 from "./FleetDetail.vue?vue&type=style&index=0&id=3c4c041c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4c041c",
  null
  
)

export default component.exports